var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bg flexs column jc-c al-c"
  }, [_c('div', {
    staticClass: "flexs column jc-c al-c margin-t-70 margin-b-70"
  }, [_c('div', {
    staticClass: "flexs column"
  }, [_c('span', {
    staticClass: "fs-32 c-303650 f-700"
  }, [_vm._v("加入我们，开启流量变现新生态")]), _c('span', {
    staticClass: "fs-16 c-586392 o-8"
  }, [_vm._v("共赢广告商业新生态")])]), _c('a', {
    staticClass: "flexs jc-c al-c fs-18 c-f back-2E6AFA padding-10 margin-t-30 w-290 radius-10",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "https://ad.jumao.net.cn/dist/"
    }
  }, [_vm._v("联系我们")])])]);
}];
export { render, staticRenderFns };